import logo from 'shared/assets/images/logo.svg';

export const Logo = () => {
  return (
    <a href='/' className='logo'>
      <img src={logo} alt="The Community Foundation for a greater Richmond" />
    </a>
  );
}
